import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '~env';
import { MemberUnpaidBill } from './member-bill.model';

const API_URL = environment.projectionQueryApi;

@Injectable({
  providedIn: 'root',
})
export class MemberBillQueryService {
  constructor(private http: HttpClient) { }

  getUnpaidBills(memberId: string, year: number): Observable<MemberUnpaidBill[]> {
    return this.http
      .get(`${API_URL}/GetUnPaidContribution(MemberId=${memberId}, Year=${year})`).pipe(
        map(res => res['value']),
        map((res: any[]) => res.map(item => this.parseMemberUnpaidBill(item)))
      )
  }

  private parseMemberUnpaidBill(item: any): MemberUnpaidBill {
    return {
      accountingBatchId: item.AccountingBatchId,
      amount: item.Amount,
      billDate: item.BillDate,
      feeTypeCode: item.FeeTypeCode,
      feeTypeId: item.FeeTypeId,
      feeTypeLabel: {
        fr: item.DescriptionFr,
        en: item.DescriptionEn,
      },
      memberBillCode: item.MemberBillCode,
      memberBillId: item.MemberBillId,
    };
  }
}
